import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	viewScriptButton: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.button.see-script.non-final',
		defaultMessage: 'See script',
		description: 'Label for the button to show the auto-generated Loom script',
	},
	readTimeImprovementLabel: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.readtime.readability-label.non-final',
		defaultMessage: 'Improve your page',
		description:
			'Small helper label shown above the Loom suggestion, indicating this section provides tips to improve readability',
	},
	readTimeLoomAIScriptTitle: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.readtime.loom-title.non-final',
		defaultMessage: 'Add summary video',
		description:
			'Main headline in the read time panel encouraging users to create a Loom video to summarize the page content',
	},
	tryLozenge: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.try-lozenge.non-final',
		defaultMessage: 'Try',
		description: 'Label for the try lozenge in the read time panel',
	},
});
